import React from "react";
import ReactDOM from 'react-dom/client';  // เปลี่ยนการนำเข้า
import App from "./App";
import { AuthProvider } from "./context/AuthContext";

// ใช้ createRoot แทน render
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
